import Layout from "@/components/feature/Layout";
import PageHero from "@/components/base/PageHero";
import SectionHeader from "@/components/base/SectionHeader";
import CTAPanel from "@/components/base/CTAPanel";

const serviceAreas = [
  {
    title: "Mobile Application Development",
    description: "Custom mobile application design and development for enterprise and government programs, built for usability and performance.",
    icon: "ri-smartphone-line",
  },
  {
    title: "iOS Application Development",
    description: "Native iOS application development and support for enterprise mobile solutions delivered through modern Apple development practices.",
    icon: "ri-apple-line",
  },
  {
    title: "Android Application Development",
    description: "Native Android application development and support for enterprise and government mobile programs.",
    icon: "ri-android-line",
  },
  {
    title: "Cross-Platform Development",
    description: "Cross-platform mobile development to deliver consistent experiences across iOS and Android from a shared codebase.",
    icon: "ri-cellphone-line",
  },
  {
    title: "API & Backend Integration",
    description: "Integration of mobile applications with enterprise data sources, APIs, and backend services.",
    icon: "ri-plug-line",
  },
  {
    title: "Mobile UX & Accessibility",
    description: "Mobile user experience design and accessibility-aware development to support diverse user populations.",
    icon: "ri-user-heart-line",
  },
  {
    title: "Mobile Testing & QA",
    description: "Testing and quality assurance for mobile applications across devices, operating systems, and connectivity conditions.",
    icon: "ri-bug-line",
  },
  {
    title: "Mobile Application Maintenance",
    description: "Ongoing maintenance, updates, and support for deployed mobile applications and digital platforms.",
    icon: "ri-tools-line",
  },
];

export default function MobileAppDevelopment() {
  return (
    <Layout>
      <PageHero
        title="Mobile Application Development"
        subtitle="Application Engineering"
        description="Custom mobile application development, cross-platform solutions, API integration, and accessibility-aware mobile UX for enterprise and government programs."
        size="md"
      />

      <section className="section-padding bg-white">
        <div className="container-page">
          <SectionHeader
            title="Service Areas"
            description="Mobile application engineering delivered as part of broader enterprise technology engagements."
          />
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {serviceAreas.map((area) => (
              <div key={area.title} className="card-base p-6">
                <div className="w-10 h-10 rounded-lg bg-primary-50 flex items-center justify-center mb-4">
                  <i className={`${area.icon} text-primary-600`}></i>
                </div>
                <h3 className="text-lg font-bold text-foreground-900 mb-2">
                  {area.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {area.description}
                </p>
              </div>
            ))}
          </div>

          <div className="mt-14 bg-background-100 rounded-lg p-6 border border-background-200/80">
            <h3 className="text-lg font-bold text-foreground-900 mb-4">
              Capability Overview
            </h3>
            <p className="text-sm text-foreground-600 leading-relaxed">
              Mobile application development covers native iOS and Android, cross-platform builds, API and backend integration, user experience, accessibility, testing, and ongoing maintenance. These services support enterprise and government modernization initiatives and are delivered as part of Mitaja's application engineering practice.
            </p>
          </div>
        </div>
      </section>

      <CTAPanel
        title="Need Mobile Development Support?"
        description="Mitaja provides mobile application development and integration as part of broader enterprise technology engagements."
        primaryAction={{ label: "Contact Us", href: "/contact" }}
        secondaryAction={{ label: "View All Capabilities", href: "/capabilities" }}
        variant="dark"
      />
    </Layout>
  );
}